import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticAutomaticMetaConfigMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.log
   * */
  constructor({config}) {
    super()
    this._config = config
    this._seoConfig = this._config.get('seo')
  }

  _getAdsListSemanticConfigKey = ({make, bodyType, province, fuelType}) => {
    const hasMake = Boolean(make)
    const hasBodyType = Boolean(bodyType)
    const hasProvince = Boolean(province)
    const hasFuelType = Boolean(fuelType)

    // These are the six combinations of SEO Metadata typologies
    // for automatic ads-list pages [/automatico/]
    const isDefault = !hasMake && !hasBodyType && !hasProvince && !hasFuelType
    const isMake = hasMake
    const isBodyType = !hasMake && hasBodyType && !hasProvince
    const isProvince = !hasMake && !hasBodyType && hasProvince
    const isBodyTypeProvince = !hasMake && hasBodyType && hasProvince
    const isFuelType = !hasMake && !hasBodyType && !hasProvince && hasFuelType

    switch (true) {
      case isDefault:
        return 'default'
      case isMake:
        return 'make'
      case isBodyType:
        return 'bodyType'
      case isProvince:
        return 'province'
      case isBodyTypeProvince:
        return 'bodyTypeProvince'
      case isFuelType:
        return 'fuelType'
      default:
        return 'default'
    }
  }

  map = ({adsListSemanticConfig, params: {make, bodyType, province, fuelType}}) => {
    const adsListSemanticConfigKey = this._getAdsListSemanticConfigKey({
      make,
      bodyType,
      province,
      fuelType
    })
    return adsListSemanticConfig[adsListSemanticConfigKey] || adsListSemanticConfig.default
  }
}
